const getDeviceInfo = () => {
  const isBrowser = !!(
    typeof window !== "undefined" &&
    window.document &&
    window.document.createElement
  );

  return {
    isBrowser,
    allowMotion:
      isBrowser && !window.matchMedia("(prefers-reduced-motion)").matches,
  };
};

export { getDeviceInfo };
